import apiClient from '@/services/axios';
import axios from 'axios';

export const revokeToken = async () => {
  try {
    await apiClient.post('/users/token/revoke', {});
    localStorage.removeItem('access_token');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Error revoking token:', error.response?.data || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
  }
};